/**
 * Componente que se encarga de recibir las peticiones enviadas desde el componente de terceros
 * en el momento de crear, editar o eliminar los registros.  Esto con el fin de que se 
 * recarguen los datos de las tablas afectadas por las datatables.
 * JMM-2018-05-17
 */
//Componente
import { Component, OnInit } from '@angular/core';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-enrutamientofichastecnicas',
  templateUrl: './enrutamientofichastecnicas.component.html'
})
export class EnrutamientofichastecnicasComponent implements OnInit {

  constructor(
    private route   : ActivatedRoute,
    private router  : Router,
    private http    : Http
  ) {}

  /**
   * Dentro de esta función se manejan los enrutamientos automáticos
   * hacia donde se enrutan las peticiones de cada componente.
   * CESAR ARIAS-2019-12-17
   */
  ngOnInit() 
  {
   
    let tipoficha     = this.route.snapshot.paramMap.get('tabset');
    let itemequipoid  = this.route.snapshot.paramMap.get('itemequipoid');
    let idequipo      = this.route.snapshot.paramMap.get('idequipo');

    // if (tipoficha != 'null') {
      this.router.navigate(['/main/fichas-tecnicas/'+tipoficha+'/'+itemequipoid+'/'+idequipo], { replaceUrl: true });
    // }else{
    //   this.router.navigate(['main/enrutamientos/enrutamientofichastecnicas/null/null/null'], { replaceUrl: true }); 
    // }
  }// .ngOnInit() 

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/enrutamientos/enrutamientofichastecnicas/enrutamientofichastecnicas.component.ts